import React, { useState, useEffect } from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Button,
    Select,
    Checkbox,
    CheckboxGroup,
    VStack,
    HStack,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    useToast,
    Text,
    Stack,
    useColorModeValue,
    Flex,
    Spinner,
    FormErrorMessage,
    Image,
    Progress,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from '@chakra-ui/react';
import ReactSelect from 'react-select';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { GrAdd } from 'react-icons/gr';
import { FaCloudUploadAlt } from 'react-icons/fa';
import axiosClient, { localUpload } from '../../../../axios-client';
import { CloseIcon } from '@chakra-ui/icons';
import TimeInput from '../../TimeInput';
import { sendToS3 } from '../../../../services/s3Upload';
import { useStateContext } from '../../../../context/ContextProvider';
const FileInput = ({ label, onChange, value, isRequired, errorMessage, accept }) => {
    const [touched, setTouched] = useState(false);
    const [preview, setPreview] = useState(null);
    const toast = useToast()
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const handleBlur = () => {
        setTouched(true);
    };
    const simulateProgress = () => {
        setIsUploading(true);
        setUploadProgress(0);
        const interval = setInterval(() => {
            setUploadProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setIsUploading(false);
                    return 100;
                }
                return prev + 10;
            });
        }, 200);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            simulateProgress();
            onChange(e);
            if (file) {
                const previewUrl = URL.createObjectURL(file);
                setPreview(previewUrl);
            }
        } catch (err) {
            // console.error("Error handling file:", err);
            setIsUploading(false);
            setUploadProgress(0);
            toast({
                title: 'Erreur',
                description: "Une erreur s'est produite lors du traitement du fichier",
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const isInvalid = isRequired && touched && !value;

    return (
        <FormControl isRequired={isRequired} isInvalid={isInvalid} onBlur={handleBlur}>
            <FormLabel>{label}</FormLabel>
            <Flex direction="column" gap={2}>
                <Flex alignItems="center">
                    <Input
                        type="file"
                        display="none"
                        id={`file-input-${label}`}
                        onChange={handleFileChange}
                        accept={accept}
                    />
                    <Button
                        as="label"
                        htmlFor={`file-input-${label}`}
                        leftIcon={<FaCloudUploadAlt />}
                        colorScheme="cyan"
                        variant="outline"
                        borderRadius="md"
                        w="100%"
                        position="relative"
                        overflow="hidden"
                        _hover={{ bgGradient: 'linear(to-r, #29a4a6, #6ad7d9)', color: 'white' }}
                    >
                        <Box position="absolute" left="0" top="0" bottom="0" width={`${uploadProgress}%`}
                            bg="cyan.100" transition="width 0.2s" opacity="0.3" />
                        <Text position="relative">
                            {value ? value.name : 'Choisir un fichier'}
                        </Text>
                    </Button>
                    {preview && (
                        <Box ml={4}>
                            {accept.includes("image") ? (
                                <Image src={preview} alt="file preview" boxSize="50px" objectFit="cover" borderRadius="md" />
                            ) : (
                                <video
                                    style={{ borderRadius: "5px" }}
                                    autoPlay
                                    loop
                                    muted
                                    src={preview}
                                    alt="file preview"
                                    width="100px"
                                    height="100px"
                                />
                            )}
                        </Box>
                    )}
                </Flex>
                {isUploading && (
                    <Flex align="center" gap={2}>
                        <Progress
                            value={uploadProgress}
                            size="xs"
                            colorScheme="cyan"
                            borderRadius="full"
                            flex="1"
                        />
                        <Text fontSize="sm" color="gray.500">
                            {uploadProgress}%
                        </Text>
                    </Flex>
                )}
            </Flex>
            {value && (
                <Text mt={2} fontSize="sm" color="gray.500">
                    {value.name}
                </Text>
            )}
            {isInvalid && (
                <FormErrorMessage>{errorMessage || 'Ce champ est requis'}</FormErrorMessage>
            )}
        </FormControl>
    );
};

const AddEpisode = () => {
    const { t } = useTranslation()
    const { user } = useStateContext()
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [releaseDate, setReleaseDate] = useState('');
    const [seasonNumber, setSeasonNumber] = useState('');
    const [episodeNumber, setEpisodeNumber] = useState('');
    const [videoUrl, setVideoUrl] = useState(null);
    const [filterChunks, setFilterChunks] = useState([]);
    const [duration, setDuration] = useState(0);
    const [etat, setEtat] = useState(true);
    const navigate = useNavigate()
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false)
    const location = useLocation()
    const titleColor = useColorModeValue('#565656', '#bfbfbf');

    const [uploadProgressSubmit, setUploadProgressSubmit] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalProgress, setModalProgress] = useState(0);


    const [intro, setIntro] = useState({ start: 0, end: 0 });
    const [outro, setOutro] = useState({ start: "", end: "" });

    useEffect(() => {
        if (!location.state?.idSerie) {
            toast({
                title: 'Accès invalide',
                description: 'Aucun ID de série trouvé.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
            navigate('/series');
        }
    }, [location.state?.idSerie, localUpload]);


    const handleVideoUpload = async (file) => {
        setVideoUrl(file);
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);

        video.onloadedmetadata = () => {
            setDuration(Math.round(video.duration));
        };
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        setUploadProgressSubmit(0);

        let formattedDate = releaseDate;
        if (releaseDate.length === 4) {
            formattedDate = `${releaseDate}-01-01`;
        }
        else {
            toast({
                title: 'Erreur de validation.',
                description: 'Veuillez entrer une année valide',
                status: 'warning',
                duration: 4000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setIsLoading(false)
            setUploadProgressSubmit(0);
            return
        }
        if ((videoUrl?.name && videoUrl?.name.length > 100)) {
            toast({
                title: 'Erreur de validation.',
                description: 'Le nom de video ne doit pas dépasser 100 caractères.',
                status: 'warning',
                duration: 4000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setIsLoading(false)
            setUploadProgressSubmit(0);
            return
        }
        // const validFilterChunks = filterChunks.filter(
        //     (chunk) =>
        //         chunk.start !== 0 &&
        //         chunk.end !== 0 &&
        //         chunk.start < chunk.end &&
        //         chunk.label.trim() !== ''
        // );
        const validFilterChunks = filterChunks.filter((chunk) => {
            // Convert start & end to seconds
            const startSeconds = chunk.start;
            const endSeconds = chunk.end;

            // Check if time values are in a valid range
            const maxSeconds = 24 * 3600 + 59 * 60 + 59.999; // 24:59:59.999

            if (startSeconds >= endSeconds || startSeconds > maxSeconds || endSeconds > maxSeconds) {
                return false;
            }

            return chunk.label.trim() !== '';
        });
        if (filterChunks.length !== validFilterChunks.length) {
            toast({
                title: 'Erreur de validation.',
                description: 'Veuillez remplir correctement toutes les sections de filtre.',
                status: 'warning',
                duration: 4000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setIsLoading(false)
            setUploadProgressSubmit(0);
            return;
        }
        const updateProgress = (progress) => {
            setUploadProgressSubmit(progress);
        };
        let videoUrlS3 = null;
        if (!localUpload) {
            /////////////////////////////////////////////////  S3 UPLOAD START /////////////////////////////////////////////////

            videoUrlS3 = videoUrl ? await sendToS3(videoUrl, "uploads/videos/episodes", updateProgress) : null;

            if (videoUrl && !videoUrlS3) {
                toast({
                    description: `Le téléchargement de vidéo a échoué.`,
                    status: "warning",
                    duration: null,
                    isClosable: true,
                    position: "bottom-right",
                    variant: "left-accent"
                });

                setIsLoading(false);
                setUploadProgressSubmit(0);
                return;
            }
            /////////////////////////////////////////////////  S3 UPLOAD  END /////////////////////////////////////////////////

        }
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('releaseDate', formattedDate);
        formData.append('serie', location.state.idSerie);
        if (localUpload) {
            //video on local
            formData.append('videoUrl', videoUrl);
        }
        else {
            //video on S3
            formData.append('videoUrl', videoUrlS3);
        }

        formData.append('duration', duration);
        formData.append('seasonNumber', seasonNumber);
        formData.append('episodeNumber', episodeNumber);
        formData.append('filter_chunks', JSON.stringify(filterChunks));
        formData.append('intro', JSON.stringify(intro));
        formData.append('outro', JSON.stringify(outro));
        formData.append('edited_by', `${user.last_name} ${user.first_name}`);
        try {
            // Check for duplicate episodes
            const checkResponse = await axiosClient.post('/check-duplicate-episode/', {
                series_id: location.state.idSerie,
                season_number: seasonNumber,
                episode_number: episodeNumber,
            });

            if (checkResponse.status === 200) {
                // If no duplicate is found, proceed with episode creation
                axiosClient.post('/episodes/create/', formData, {
                    onUploadProgress: (progressEvent) => {
                        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        if (percentCompleted >= 99) percentCompleted = 99;
                        setUploadProgressSubmit(percentCompleted);
                        setModalProgress(percentCompleted);
                        if (percentCompleted === 99) {
                            setIsModalOpen(true); // Open modal when it reaches 99%
                        }
                    }
                })
                    .then((response) => {
                        toast({
                            description: 'Épisode ajouté avec succès.',
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right",
                            variant: "left-accent",
                        });
                        navigate(-1);
                        setIsLoading(false)
                        setIsModalOpen(false);
                        setUploadProgressSubmit(0);
                    })
                    .catch((err) => {
                        const response = err.response;
                        toast({
                            // title: 'Error.',
                            description: "Une erreur s'est produite.",
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            variant: 'left-accent'
                        });
                        // console.error(response);
                        setIsLoading(false)
                        setIsModalOpen(false);
                        setUploadProgressSubmit(0);
                    });
            }
        } catch (error) {
            if (error.response?.status === 409) {
                // Duplicate episode found
                toast({
                    title: 'Erreur.',
                    description: "Un épisode avec ce numéro de saison et d'épisode existe déjà pour cette série.",
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    variant: "left-accent",
                    position: "bottom-right",
                });
                setIsLoading(false)
                setIsModalOpen(false);
                setUploadProgressSubmit(0);
            } else {
                // Other errors

                const errorMessage = error.response?.data?.message || "Une erreur s'est produite.";
                toast({
                    title: 'Erreur.',
                    description: errorMessage,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
                setIsModalOpen(false);
                setIsLoading(false)
                setUploadProgressSubmit(0);
            }
        }
    };



    const handleAddFilterChunk = () => {
        setFilterChunks([...filterChunks, { start: 0, end: 0, label: '' }]);
    };

    const handleDeleteFilterChunk = (index) => {
        setFilterChunks((prevChunks) => prevChunks.filter((_, i) => i !== index));
    };
    const handleFilterChunkChange = (index, key, value) => {
        const updatedChunks = [...filterChunks];
        updatedChunks[index][key] = value;
        setFilterChunks(updatedChunks);
    };
    const isEmpty = () => {
        return !title.trim() || !description.trim() || !releaseDate || !videoUrl || !episodeNumber || !seasonNumber
    };

    const convertSecondsToTime = (seconds) => {
        if (!seconds) return "00:00:00"; // Default format
        const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${hrs}:${mins}:${secs}`;
    };

    const convertTimeToSeconds = (time) => {
        const [hrs, mins, secs] = time.split(":").map(Number);
        return (hrs || 0) * 3600 + (mins || 0) * 60 + (secs || 0);
    };

    const handleTimeChange = (index, field, value) => {
        const seconds = convertTimeToSeconds(value);
        handleFilterChunkChange(index, field, seconds);
    };

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m ` : ""}${secs}s`;
    };

    const handleYearChange = (e) => {
        let year = e.target.value;

        // Allow only numeric input and ensure the length doesn't exceed 4 characters
        year = year.replace(/\D/g, '');  // Remove any non-digit characters
        if (year.length <= 4) {
            setReleaseDate(year);
        }
    };
    return (
        <Box>
            <Box w={"100%"} mt={3} mb={2}>
                <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>
                    / <span onClick={() => navigate('/series')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Liste des séries')}</span>
                    / <span onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Détails de la série')}</span>
                    / <span style={{ color: titleColor }}> {t('Ajouter un épisode')}</span></Text>
            </Box>
            <Flex
                direction={{ base: 'column', md: 'row' }}
                align={{ base: 'stretch', md: 'center' }}
                justify={"center"}
                p={5}
            >

                <Stack bg={useColorModeValue('white', 'gray.700')}
                    rounded={'lg'}
                    p={6}
                    my={5}
                    w={{ base: '100%', md: '100%', lg: '70%', sm: '100%' }}
                >
                    <Box p={5} rounded={'lg'} w="100%" maxW="full" justify={'center'}>
                        <Stack spacing={3} w={{ base: '100%', md: '100%', lg: '100%', sm: '100%' }}>
                            <FormControl isRequired>
                                <FormLabel>Titre</FormLabel>
                                <Input
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Entrez le titre"
                                />
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel>Description</FormLabel>
                                <Textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Entrez une description"
                                />
                            </FormControl>
                            <Flex gap={3} direction={{ base: 'column', md: "row" }}>
                                <FormControl isRequired>
                                    <FormLabel>Saison</FormLabel>
                                    <Input
                                        type="text"
                                        value={seasonNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d+$/.test(value) || value === "") {
                                                setSeasonNumber(value);
                                            }
                                        }}
                                        placeholder="Entrez le numéro de saison"
                                    />
                                </FormControl>
                                <FormControl isRequired>
                                    <FormLabel>Episode</FormLabel>
                                    <Input
                                        type="text"
                                        value={episodeNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d+$/.test(value) || value === "") {
                                                setEpisodeNumber(value);
                                            }
                                        }}
                                        placeholder="Entrez le numéro de l'épisode"
                                    />
                                </FormControl>
                            </Flex>

                            <FormControl isRequired>
                                <FormLabel>Année de sortie</FormLabel>
                                <Input
                                    type="text"  // Allow input of only year
                                    value={releaseDate ? releaseDate.split('-')[0] : ''} // Display only the year part
                                    onChange={handleYearChange}
                                    placeholder="Entrez l'année"
                                    maxLength={4}
                                />
                            </FormControl>



                            <FileInput
                                label="Vidéo"
                                value={videoUrl}
                                onChange={(e) => handleVideoUpload(e.target.files[0])}
                                isRequired
                                errorMessage="Veuillez télécharger une vidéo."
                                accept="video/*"
                            />

                            <FormControl isRequired>
                                <FormLabel>Durée </FormLabel>
                                {/* <NumberInput value={duration} isReadOnly>
                                    <NumberInputField placeholder="Durée en secondes" />
                                </NumberInput> */}
                                <Input isReadOnly value={formatTime(duration)} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>Intro (sauter l'intro)</FormLabel>
                                <HStack spacing={3}>
                                    <TimeInput
                                        value={intro.start}
                                        onChange={(newTime) => setIntro((prev) => ({ ...prev, start: newTime || 0}))}
                                    />
                                    <TimeInput
                                        value={intro.end}
                                        onChange={(newTime) => setIntro((prev) => ({ ...prev, end: newTime || 0}))}
                                    />
                                </HStack>
                            </FormControl>

                            <FormControl mt={3}>
                                <FormLabel>Outro ((sauter l'outro))</FormLabel>
                                <HStack spacing={3}>
                                    <TimeInput
                                        value={outro.start}
                                        onChange={(newTime) => setOutro((prev) => ({ ...prev, start: newTime }))}
                                    />
                                    <TimeInput
                                        value={outro.end}
                                        onChange={(newTime) => setOutro((prev) => ({ ...prev, end: newTime }))}
                                    />
                                </HStack>
                            </FormControl>


                            <FormControl>
                                <FormLabel>Filtres par section</FormLabel>
                                {filterChunks.map((chunk, index) => (
                                    <HStack key={index} my={3} spacing={3}>
                                        {/* Start Time Input */}
                                        <TimeInput
                                            value={chunk.start}
                                            onChange={(newTime) => handleFilterChunkChange(index, "start", newTime)}
                                        />

                                        {/* End Time Input */}
                                        <TimeInput
                                            value={chunk.end}
                                            onChange={(newTime) => handleFilterChunkChange(index, "end", newTime)}
                                        />

                                        {/* Select Label */}
                                        <Select
                                            placeholder="Étiquette"
                                            value={chunk.label}
                                            onChange={(e) => handleFilterChunkChange(index, "label", e.target.value)}
                                        >
                                            <option value="NUDITÉ">Nudité</option>
                                            <option value="SCÈNE INTIME">Scène intime</option>
                                            <option value="VIOLENCE PHYSIQUE">Violence physique</option>
                                            <option value="VULGARITÉ SONORE">Vulgarité sonore</option>
                                            <option value="VULGARITÉ VISUELLE">Vulgarité visuelle</option>
                                        </Select>

                                        {/* Delete Button */}
                                        <CloseIcon
                                            cursor="pointer"
                                            aria-label="Delete filter section"
                                            color="red"
                                            variant="outline"
                                            onClick={() => handleDeleteFilterChunk(index)}
                                        />
                                    </HStack>
                                ))}
                                <Button variant="link" colorScheme="cyan" mt={1} onClick={handleAddFilterChunk}>
                                    Ajouter un filtre
                                </Button>
                            </FormControl>

                            {/* <FormControl>
                                <Checkbox
                                    isChecked={etat}
                                    onChange={(e) => setEtat(e.target.checked)}
                                >
                                    Actif
                                </Checkbox>
                            </FormControl> */}
                            <Stack direction={['column', 'row']} spacing={10} pt={2} justifyContent="end">
                                {isEmpty() ? (
                                    <Button
                                        type="submit"
                                        onClick={handleSubmit}
                                        colorScheme="green"
                                        isDisabled
                                        leftIcon={<GrAdd />}
                                    >
                                        Ajouter
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        onClick={handleSubmit}
                                        colorScheme="green"
                                        isDisabled={isLoading}
                                        leftIcon={!isLoading && <GrAdd />}
                                    >
                                        {(isLoading && !isModalOpen) ?
                                            <Flex align="center" gap={2}>
                                                <Spinner size="sm" />
                                                <Text>Chargement en cours... {uploadProgressSubmit}%</Text>
                                            </Flex> : "Ajouter"}
                                    </Button>
                                )}
                            </Stack>
                        </Stack>
                    </Box>
                    <Modal size={"lg"} closeOnOverlayClick={false} isOpen={isModalOpen} isCentered>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Chargement en cours</ModalHeader>
                            {/* <ModalCloseButton /> */}
                            <ModalBody>
                                <Text mb={5}>Veuillez patienter pendant que nous préparons vos fichiers.</Text>
                                <Progress value={modalProgress} size="md" colorScheme="teal" isIndeterminate={modalProgress < 100} />
                                {/* <Text mt={2} textAlign="center">{modalProgress}%</Text> */}
                            </ModalBody>
                            <ModalFooter />
                        </ModalContent>
                    </Modal>
                </Stack>
            </Flex>
        </Box>
    );
};

export default AddEpisode;
